// @flow
import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Card from "@material-ui/core/Card";
import type { Alert as AlertType } from '../../types';
import AlertIcon from './AlertIcon';
import CardHeader from "@material-ui/core/CardHeader";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import CardContent from "@material-ui/core/CardContent";

type AlertDataType = $ReadOnly<{
    type: $PropertyType<AlertType, 'type'>,
    meta: $PropertyType<AlertType, 'meta'>,
    seen: boolean,
    message?: string,
    callsign?: string,
    date?: string,
    user?: string,
    zone?: string,
}>;

const NA = (
    <FormattedMessage
        id="general.na"
        defaultMessage="N/A"
    />
);

const unknown = (
    <FormattedMessage
        id="alert.type.unknown"
        defaultMessage="Unknown"
    />
);

const useStyles = makeStyles(theme => ({
    unread: {
        borderRight: '13px solid yellow'
    },
    card: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    },
    cardHeader: {
        paddingBottom: 0
    },
    listItemIcon: {
        marginRight: '1ch'
    },
    listItem: {
        padding: 0
    },
    cardContent: {
        '&:last-child': {
            paddingBottom: 16
        }
    }
}));

export type Props = $ReadOnly<{
    alert: AlertDataType
}>;

function Alert({ alert }: Props) {
    const classes = useStyles();

    const alertIcon = <AlertIcon alert={alert}/>;

    return (
        <Card raised={false}
              classes={{root: classes.card}}
              className={classnames({
                  [classes.unread]: !alert.seen
              })}
        >
            <CardHeader
                classes={{root: classes.cardHeader, subheader: classes.subheader}}
                avatar={alertIcon}
                title={alert.message || unknown}
                subheader={alert.date || NA}
            />

            <CardContent classes={{ root: classes.cardContent }}>
                <List dense={true} disablePadding={true}>
                    <ListItem classes={{ root: classes.listItem }}>
                        <ListItemIcon classes={{root: classes.listItemIcon}}>
                            <FormattedMessage
                                id="alert.label.callsign"
                                defaultMessage="Callsign"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={alert.callsign || NA}
                        />
                    </ListItem>
                    <ListItem classes={{ root: classes.listItem }}>
                        <ListItemIcon classes={{root: classes.listItemIcon}}>
                            <FormattedMessage
                                id="alert.label.operator"
                                defaultMessage="Operator"
                            />
                        </ListItemIcon>
                        <ListItemText
                            primary={alert.user || NA}
                        />
                    </ListItem>
                </List>
            </CardContent>

            {/*<AlertIcon alert={alert} /> {alert.message || unknown}*/}
            {/*<Table>*/}
            {/*    <TableBody>*/}
            {/*        <TableRow>*/}
            {/*            <TableCell>*/}
            {/*                <FormattedMessage*/}
            {/*                    id="alert.label.callsign"*/}
            {/*                    defaultMessage="Callsign"*/}
            {/*                />: {alert.callsign || NA}*/}
            {/*            </TableCell>*/}
            {/*            <TableCell>*/}
            {/*                <FormattedMessage*/}
            {/*                    id="alert.label.operator"*/}
            {/*                    defaultMessage="Operator"*/}
            {/*                />: {alert.user || NA}*/}
            {/*            </TableCell>*/}
            {/*        </TableRow>*/}
            {/*        /!*<TableRow>*!/*/}
            {/*        /!*    <TableCell colSpan={2}>*!/*/}
            {/*        /!*        {alert.date || NA}*!/*/}
            {/*        /!*    </TableCell>*!/*/}
            {/*        /!*</TableRow>*!/*/}
            {/*    </TableBody>*/}
            {/*</Table>*/}
        </Card>
    );
}

export default React.memo(Alert);